import axios from "axios";
import { API_URL, authHeader } from "./api";

const options = hotelId => ({ headers: authHeader(), params: { hotelId } });
const AutomationService = {
  list: hotelId => axios.get(`${API_URL}automations`, options(hotelId)),
  change: (hotelId, command) => axios.post(`${API_URL}automations`, command, options(hotelId)),
  history: hotelId => axios.get(`${API_URL}automations/history`, options(hotelId)),
};
export default AutomationService;
